import { render, staticRenderFns } from "./ParametrosItem.vue?vue&type=template&id=69d1263d&scoped=true"
import script from "./ParametrosItem.vue?vue&type=script&lang=js"
export * from "./ParametrosItem.vue?vue&type=script&lang=js"
import style0 from "./ParametrosItem.vue?vue&type=style&index=0&id=69d1263d&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d1263d",
  null
  
)

export default component.exports